const tokenReducer =(state="", action)=>{
    switch(action.type){
        case "SET_ADMIN_TOKEN":
            localStorage.setItem('auth_admin',action.payload);
            return state=action.payload;
        case "GET_ADMIN_TOKEN":
            return state;
            default:
                return state; 
    }
}

export default tokenReducer;